import { DomainError } from 'src/models/DomainError';

export default async function validateQuickReply(attrs) {
  const { onboarding } = attrs.configuration;
  const er = [] as any[];
  onboarding.messages.forEach((message, messageIndex) => {
    if (message.subType === 'QUICK_REPLY_REQUEST') {
      const errors = ValidateQuickReplyOptions(message.subTypeContent.options, messageIndex);
      er.push(...errors);
    }
  });
  return er as DomainError[];
}

function ValidateQuickReplyOptions(options, index) {
  const labelErrors = ValidateLabels(options, index);
  const idErrors = ValidateButtonIds(options, index);
  return [...labelErrors, ...idErrors];
}

function ValidateLabels(options, messageIndex) {
  const errors = [] as any[];
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    const index = options.findIndex(o => o.label === option.label);
    if (index != i) {
      errors.push({
        attr: `configuration.onboarding.messages[${messageIndex}].subTypeContent.options[${i}].label`,
        code: 'duplicate',
        detail: 'Duplicate label. Please use a unique label.',
      });
    }
  }
  return errors;
}

function ValidateButtonIds(options, messageIndex) {
  const errors = [] as any[];
  for (let i = 0; i < options.length; i++) {
    const option = options[i];
    const index = options.findIndex(o => o.buttonId === option.buttonId);
    if (index != i) {
      errors.push({
        attr: `configuration.onboarding.messages[${messageIndex}].subTypeContent.options[${i}].buttonId`,
        code: 'duplicate',
        detail: 'Duplicate ID. Please use a unique ID.',
      });
    }
  }
  return errors;
}
